import { render, staticRenderFns } from "./Slogen.vue?vue&type=template&id=1983e387&scoped=true&"
import script from "./Slogen.vue?vue&type=script&lang=js&"
export * from "./Slogen.vue?vue&type=script&lang=js&"
import style0 from "./Slogen.vue?vue&type=style&index=0&id=1983e387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983e387",
  null
  
)

export default component.exports